import { IQueryParams } from '../types/routing';

export const buildEndpointRoute = (endpoint: string, params: IQueryParams) => {
  // Replace path parameters like {:id} or :id with actual values from params
  return endpoint.replace(/\{?:(\w+)\}?/g, (_, paramName) => {
    const value = params[paramName];
    if (value === undefined || value === null || value === '') {
      throw new Error(
        `Missing required path parameter: "${paramName}". Expected a valid value but received "${value}"`,
      );
    }
    // Encoded because ids can be provider-sourced (marketplace): a raw `/`, `?` or `#`
    // would otherwise silently retarget the request path.
    return encodeURIComponent(String(value));
  });
};
